import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { IntegrationData } from '../../integrations/types';
import { SaveIntegrationDataProvider } from '../dataProvider/SaveIntegrationDataProvider';
import { SaveIntegrationFactory } from '../factory/SaveIntegrationFactory';

export class SaveIntegrationRepository extends BaseWebComponentRepository {
  public dataProviderFactory: SaveIntegrationFactory;
  public dataProvider: SaveIntegrationDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new SaveIntegrationFactory(),
    });
  }

  public async getIntegrationById(integrationId: string | null): Promise<IntegrationData<unknown>> {
    return this.dataProvider.getIntegrationById(integrationId);
  }

  async getDataForView(): Promise<any> {
    return this.dataProvider.getDataForView();
  }
}
